import React, { useRef, useEffect } from 'react'
import styles from './Header.module.scss'
import Logo from './Logo'
import MenuBar from './MenuBar'
import BurgerMenu from 'components/commons/Header/BurgerMenu'
import LPUIUXHeader from './LPHeader/UIUX/LPHeader'
import LPFrontendHeader from './LPHeader/Frontend/LPHeader'
import LPDesignSystemHeader from './LPHeader/DesignSystem/LPHeader'
import LPFlamingoHeader from './LPHeader/Flamingo/LPHeader'
import { useRouter } from 'next/router'
import { gsap } from 'gsap'
import ReactHtmlParser from 'react-html-parser'

const Header: React.FC = () => {
  const router = useRouter()
  const header = useRef<HTMLHeadingElement>(null)
  const flex = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (flex.current) {
      gsap.fromTo(flex.current, { opacity: 0 }, { opacity: 1 })
    }
  }, [router.pathname])

  const isUIUXLpPage: boolean = new RegExp(/\/uiuxdesign-lp2|\/lp-ui-contact-completed/).test(router.pathname)
  const isDesignSystemLpPage: boolean = new RegExp(/\/designsystem|\/lp-designsystem-contact-completed/).test(
    router.pathname,
  )
  const isFrontendBackendLpPage: boolean = new RegExp(
    /\/frontend-dev|\/lp-frontend-contact-completed|\/backend-dev|\/lp-backend-contact-completed/,
  ).test(router.pathname)
  const isAgreementPage: boolean = new RegExp(/\/agreement/).test(router.pathname)
  const isFlamingoPage: boolean = router.pathname.includes('/services/flamingo')

  const htmlContent = `
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" hidden>
        <symbol viewBox="0 0 24 24" id="svg-arrow" preserveAspectRatio="none">
            <path fill="currentColor" d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8Z"/>
        </symbol>
        <symbol viewBox="0 0 20 20" id="svg-external" preserveAspectRatio="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H8.33333C8.79357 2.5 9.16667 2.8731 9.16667 3.33333C9.16667 3.79357 8.79357 4.16667 8.33333 4.16667H5C4.77899 4.16667 4.56702 4.25446 4.41074 4.41074C4.25446 4.56702 4.16667 4.77899 4.16667 5V15C4.16667 15.221 4.25446 15.433 4.41074 15.5893C4.56702 15.7455 4.77899 15.8333 5 15.8333H15C15.221 15.8333 15.433 15.7455 15.5893 15.5893C15.7455 15.433 15.8333 15.221 15.8333 15V11.6667C15.8333 11.2064 16.2064 10.8333 16.6667 10.8333C17.1269 10.8333 17.5 11.2064 17.5 11.6667V15C17.5 15.663 17.2366 16.2989 16.7678 16.7678C16.2989 17.2366 15.663 17.5 15 17.5H5C4.33696 17.5 3.70107 17.2366 3.23223 16.7678C2.76339 16.2989 2.5 15.663 2.5 15V5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223ZM12.5 4.16667C12.0398 4.16667 11.6667 3.79357 11.6667 3.33333C11.6667 2.8731 12.0398 2.5 12.5 2.5H16.6667C17.1269 2.5 17.5 2.8731 17.5 3.33333V7.5C17.5 7.96024 17.1269 8.33333 16.6667 8.33333C16.2064 8.33333 15.8333 7.96024 15.8333 7.5V5.34518L10.5893 10.5893C10.2638 10.9147 9.73618 10.9147 9.41074 10.5893C9.08531 10.2638 9.08531 9.73618 9.41074 9.41074L14.6548 4.16667H12.5Z" fill="currentColor"/>
        </symbol>
    </svg>
  <header class="prj-header">
    <div class="prj-header__container">
        <div class="prj-header__flex">

            <div class="prj-header__logo">
                <a href="/" class="prj-header__logo--link no-icon">
                    <img src="/images/logo/logo_i3design.svg" alt="i3DESIGN" class="c-image__normal">
                </a>
            </div>

            <div class="c-display__block--xl prj-header__nav">
                <nav class="prj-header__nav--inner">
                    <ul class="prj-header__nav--list">
                        <li data-js-header-nav-item="" class="prj-header__nav--item">
                            <a data-js-hover="" data-enter-time="500" data-leave-time="500"
                                href="javascript:void(0)" class="prj-header__nav--link c-link__nav">
                                <p class="--text prj-header__nav--text font-upgrade">Services</p>
                            </a>
                            <div data-js-header-modal="" class="prj-header__modal c-effect__modal">
                                <div data-js-header-modal-content="" class="--content prj-header__modal--content">
                                    <div class="prj-header__modal--inner">
                                        <!-- <div class="prj-header__modal--heading">
                                            <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                href="/services"
                                                class="prj-header__modal--link c-link__inline">
                                                <p class="--text prj-header__modal--title font-upgrade">Services</p>
                                                <div class="prj-header__modal--icon">
                                                    <svg viewBox="0 0 24 24" class="--icon c-icon__full">
                                                        <use xlink:href="#svg-arrow"></use>
                                                    </svg>
                                                </div>
                                            </a>
                                        </div> -->
                                        <div class="prj-header__modal--heading">
                                            <p class="--text prj-header__modal--title font-upgrade">Services</p>
                                        </div>

                                        <div class="prj-header__modal--nav">
                                            <div class="prj-header__modal--item">
                                                <!-- <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                                    href="/services#modern-application-development"
                                                    class="prj-header__modal--link c-link__main">
                                                    <p class="--text prj-header__modal--nav--title">モダンアプリケーション開発</p>
                                                </a> -->
                                                <p class="--text prj-header__modal--nav--title">モダンアプリケーション開発</p>
                                                <ul class="prj-header__modal--nav--list">
                                                    <li class="prj-header__modal--nav--item --first">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/application-development"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">
                                                                    アプリケーション開発</p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                    <li class="prj-header__modal--nav--item --first">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/dev-modernize"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">
                                                                    AI開発モダナイズ支援</p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                    <li class="prj-header__modal--nav--item ">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/devops"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">DevOps構築
                                                                </p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                    <li class="prj-header__modal--nav--item --last">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/cloudnative"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">クラウドネイティブ
                                                                </p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="prj-header__modal--item">
                                                <p class="--text prj-header__modal--nav--title">デジタルプロダクトデザイン</p>
                                                <ul class="prj-header__modal--nav--list">
                                                    <li class="prj-header__modal--nav--item --first">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/uiuxdesign"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">UI/UXデザイン
                                                                </p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                    <li class="prj-header__modal--nav--item ">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/design-system"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">
                                                                    デザインシステム構築</p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                    <li class="prj-header__modal--nav--item ">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/frontend-dev"
                                                            class="prj-header__modal--nav--link c-link__inline"
                                                            target="_blank">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">
                                                                    フロントエンド開発</p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 20 20"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-external"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="prj-header__modal--item">
                                                <p class="--text prj-header__modal--nav--title">プロダクト成長支援</p>
                                                <ul class="prj-header__modal--nav--list">
                                                    <li class="prj-header__modal--nav--item --first">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/strategy"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">事業戦略策定
                                                                </p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                    <li class="prj-header__modal--nav--item --last">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/pdm-pmm"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">PdM/PMM体制実行支援
                                                                </p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="prj-header__modal--item">
                                                <p class="--text prj-header__modal--nav--title">製品・サービス</p>
                                                <ul class="prj-header__modal--nav--list">
                                                    <li class="prj-header__modal--nav--item --first">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="https://eland.jp/"
                                                            class="prj-header__modal--nav--link c-link__inline"
                                                            target="_blank">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">ELAND
                                                                </p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 20 20"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-external"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                    <li class="prj-header__modal--nav--item --last">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/services/flamingo"
                                                            class="prj-header__modal--nav--link c-link__inline"
                                                            target="_blank">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">flamingo
                                                                </p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 20 20"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-external"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li data-js-header-nav-item="" class="prj-header__nav--item">
                            <a data-js-hover="" data-enter-time="500" data-leave-time="500"
                                href="/cases" class="prj-header__nav--link c-link__nav">
                                <p class="--text prj-header__nav--text font-upgrade">Case study</p>
                            </a>
                        </li>
                        <li data-js-header-nav-item="" class="prj-header__nav--item">
                            <a data-js-hover="" data-enter-time="500" data-leave-time="500"
                                href="/about" class="prj-header__nav--link c-link__nav">
                                <p class="--text prj-header__nav--text font-upgrade">About</p>
                            </a>
                            <div data-js-header-modal="" class="prj-header__modal c-effect__modal --single">
                                <div data-js-header-modal-content="" class="--content prj-header__modal--content">
                                    <div class="prj-header__modal--inner">
                                        <div class="prj-header__modal--heading">
                                            <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                href="/about"
                                                class="prj-header__modal--link c-link__inline">
                                                <p class="--text prj-header__modal--title font-upgrade">About</p>
                                                <div class="prj-header__modal--icon">
                                                    <svg viewBox="0 0 24 24" class="--icon c-icon__full">
                                                        <use xlink:href="#svg-arrow"></use>
                                                    </svg>
                                                </div>
                                            </a>
                                        </div>

                                        <div class="prj-header__modal--nav">
                                            <div class="prj-header__modal--item">
                                                <ul class="prj-header__modal--nav--list">
                                                    <li class="prj-header__modal--nav--item --first">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/mvv"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">当社が目指しているもの</p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li data-js-header-nav-item="" class="prj-header__nav--item">
                            <a data-js-hover="" data-enter-time="500" data-leave-time="500"
                                href="/news/page/1" class="prj-header__nav--link c-link__nav">
                                <p class="--text prj-header__nav--text font-upgrade">Topics</p>
                            </a>
                            <div data-js-header-modal="" class="prj-header__modal c-effect__modal --single">
                                <div data-js-header-modal-content="" class="--content prj-header__modal--content">
                                    <div class="prj-header__modal--inner">
                                        <div class="prj-header__modal--heading">
                                            <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                href="/news/page/1"
                                                class="prj-header__modal--link c-link__inline">
                                                <p class="--text prj-header__modal--title font-upgrade">Topics</p>
                                                <div class="prj-header__modal--icon">
                                                    <svg viewBox="0 0 24 24" class="--icon c-icon__full">
                                                        <use xlink:href="#svg-arrow"></use>
                                                    </svg>
                                                </div>
                                            </a>
                                        </div>

                                        <div class="prj-header__modal--nav">
                                            <div class="prj-header__modal--item">
                                                <ul class="prj-header__modal--nav--list">
                                                    <li class="prj-header__modal--nav--item --first">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/news/page/1"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">News</p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                    <li class="prj-header__modal--nav--item ">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/pressrelease/page/1"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">Press
                                                                    release</p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                    <li class="prj-header__modal--nav--item --last">
                                                        <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                            href="/events/page/1"
                                                            class="prj-header__modal--nav--link c-link__inline">
                                                            <div class="prj-header__modal--nav--inner">
                                                                <p class="--text prj-header__modal--nav--text">
                                                                    Event/Seminer</p>
                                                                <div class="prj-header__modal--icon --sm">
                                                                    <svg viewBox="0 0 24 24"
                                                                        class="--icon c-icon__full">
                                                                        <use xlink:href="#svg-arrow"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <!--
                                                                          -->
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li data-js-header-nav-item="" class="prj-header__nav--item">
                            <a data-js-hover="" data-enter-time="500" data-leave-time="500" href="/in-pocket"
                                class="prj-header__nav--link c-link__nav">
                                <p class="--text prj-header__nav--text font-upgrade">Blog</p>
                            </a>
                        </li>
                        <li data-js-header-nav-item="" class="prj-header__nav--item">
                            <a data-js-hover="" data-enter-time="500" data-leave-time="500"
                                href="/recruit" class="prj-header__nav--link c-link__nav">
                                <p class="--text prj-header__nav--text font-upgrade">Recruit</p>
                            </a>
                        </li>
                    </ul>
                    <div class="prj-header__nav--cta">

                        <div class="c-button__base  --full color-download">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                href="/download" class="c-button__base--link c-link__button">
                                <span class="--bg c-button__base--bg"></span>
                                <p class="--text c-button__base--text">資料ダウンロード</p>
                            </a>
                        </div>

                        <div class="c-button__base  --full color-contact">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                href="/contact" class="c-button__base--link c-link__button">
                                <span class="--bg c-button__base--bg"></span>
                                <p class="--text c-button__base--text">お問い合わせ</p>
                            </a>
                        </div>
                    </div>
                </nav>
            </div>

            <div class="c-display__hidden--xl prj-header__drawer">
                <button data-js-header-drawer="" type="button" class="c-button__drawer c-effect__drawer">
                    <span class="c-button__drawer--inner">
                        <span class="c-button__drawer--line --before"></span>
                        <span class="c-button__drawer--line --center"></span>
                        <span class="c-button__drawer--line --after"></span>
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="c-effect__menu c-display__hidden--xl prj-header__menu">
        <span class="prj-header__menu--mask"></span>
        <div class="prj-header__menu--inner">
            <span class="prj-header__menu--bg"></span>


            <nav class="c-site-menu ">
                <ul class="c-site-menu__list">
                    <li class="--item c-site-menu__item" style="--delay: 0ms;">
                        <a href="/" class="c-site-menu__link">
                            <p class="--text c-site-menu__text font-upgrade">Top</p>
                        </a>
                    </li>
                    <li class="--item c-site-menu__item" style="--delay: 50ms;">
                        <div data-js-accordion="true" class="c-site-menu__item--inner">
                            <button type="button" class="c-site-menu__button c-effect__accordion is-show">
                                <p class="c-site-menu__text font-upgrade">Services</p>
                                <div class="--icon c-icon__accordion"></div>
                            </button>
                            <div data-js-accordion-target="" class="c-site-menu__children " style="height: auto;">
                                <div class="c-site-menu__children--inner">
                                    <!-- <div class="c-site-menu__heading">
                                        <a href="/services"
                                            class="c-site-menu__children--link">
                                            <p class="--text c-site-menu__children--text">Services</p>
                                            <div class="c-site-menu__icon">
                                                <svg viewBox="0 0 16 16" class="c-icon__full">
                                                    <use xlink:href="#svg-arrow"></use>
                                                </svg>
                                            </div>
                                        </a>
                                    </div> -->
                                    <div data-js-accordion="" class="c-site-menu__children--item ">
                                        <button type="button" class="c-site-menu__button --border c-effect__accordion">
                                            <p class="--text c-site-menu__button--text font-sans">モダンアプリケーション開発
                                            </p>
                                            <div class="--icon c-icon__accordion"></div>
                                        </button>
                                        <div data-js-accordion-target="" class="c-site-menu__children--nav"
                                            style="height: 0px;">
                                            <div class="c-site-menu__children--list">
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/application-development"
                                                        class="c-site-menu__children--link ">
                                                        <p class="--text c-site-menu__children--text">アプリケーション開発</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/dev-modernize"
                                                        class="c-site-menu__children--link ">
                                                        <p class="--text c-site-menu__children--text">AI開発モダナイズ支援</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/devops"
                                                        class="c-site-menu__children--link ">
                                                        <p class="--text c-site-menu__children--text">DevOps構築</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/cloudnative"
                                                        class="c-site-menu__children--link --last">
                                                        <p class="--text c-site-menu__children--text">クラウドネイティブ</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div data-js-accordion="" class="c-site-menu__children--item ">
                                        <button type="button" class="c-site-menu__button --border c-effect__accordion">
                                            <p class="--text c-site-menu__button--text font-sans">デジタルプロダクトデザイン</p>
                                            <div class="--icon c-icon__accordion"></div>
                                        </button>
                                        <div data-js-accordion-target="" class="c-site-menu__children--nav"
                                            style="height: 0px;">
                                            <div class="c-site-menu__children--list">
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/uiuxdesign"
                                                        class="c-site-menu__children--link ">
                                                        <p class="--text c-site-menu__children--text">UI/UXデザイン</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/design-system"
                                                        class="c-site-menu__children--link ">
                                                        <p class="--text c-site-menu__children--text">デザインシステム構築
                                                        </p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/frontend-dev"
                                                        class="c-site-menu__children--link --last"
                                                        target="_blank">
                                                        <p class="--text c-site-menu__children--text">フロントエンド開発</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-external"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div data-js-accordion="" class="c-site-menu__children--item ">
                                        <button type="button" class="c-site-menu__button --border c-effect__accordion">
                                            <p class="--text c-site-menu__button--text font-sans">プロダクト成長支援</p>
                                            <div class="--icon c-icon__accordion"></div>
                                        </button>
                                        <div data-js-accordion-target="" class="c-site-menu__children--nav"
                                            style="height: 0px;">
                                            <div class="c-site-menu__children--list">
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/strategy"
                                                        class="c-site-menu__children--link ">
                                                        <p class="--text c-site-menu__children--text">事業戦略策定</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/pdm-pmm"
                                                        class="c-site-menu__children--link --last">
                                                        <p class="--text c-site-menu__children--text">PdM/PMM体制実行支援</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div data-js-accordion="" class="c-site-menu__children--item --last">
                                        <button type="button" class="c-site-menu__button --border c-effect__accordion">
                                            <p class="--text c-site-menu__button--text font-sans">製品・サービス</p>
                                            <div class="--icon c-icon__accordion"></div>
                                        </button>
                                        <div data-js-accordion-target="" class="c-site-menu__children--nav"
                                            style="height: 0px;">
                                            <div class="c-site-menu__children--list">
                                                <div class="c-site-menu__children--item">
                                                    <a href="https://eland.jp/"
                                                        class="c-site-menu__children--link "
                                                        target="_blank">
                                                        <p class="--text c-site-menu__children--text">ELAND</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-external"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/services/flamingo"
                                                        class="c-site-menu__children--link --last"
                                                        target="_blank">
                                                        <p class="--text c-site-menu__children--text">flamingo</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-external"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="--item c-site-menu__item" style="--delay: 100ms;">
                        <div class="c-site-menu__item--inner">
                            <a href="/cases" class="c-site-menu__link">
                                <p class="--text c-site-menu__text font-upgrade">Case study</p>
                            </a>
                        </div>
                    </li>
                    <li class="--item c-site-menu__item" style="--delay: 150ms;">
                        <div data-js-accordion="" class="c-site-menu__item--inner">
                            <button type="button" class="c-site-menu__button c-effect__accordion">
                                <p class="c-site-menu__text font-upgrade">About</p>
                                <div class="--icon c-icon__accordion"></div>
                            </button>
                            <div data-js-accordion-target="" class="c-site-menu__children --single"
                                style="height: 0px;">
                                <div class="c-site-menu__children--inner">
                                    <div class="c-site-menu__children--item --last">
                                        <div data-js-accordion-target="" class="c-site-menu__children--nav">
                                            <div class="c-site-menu__children--list">
                                                <div class="c-site-menu__children--item">
                                                    <a href="/about"
                                                        class="c-site-menu__children--link --last">
                                                        <p class="--text c-site-menu__children--text">About</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/mvv"
                                                        class="c-site-menu__children--link --last">
                                                        <p class="--text c-site-menu__children--text">当社が目指しているもの</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="--item c-site-menu__item" style="--delay: 200ms;">
                        <div data-js-accordion="" class="c-site-menu__item--inner">
                            <button type="button" class="c-site-menu__button c-effect__accordion">
                                <p class="c-site-menu__text font-upgrade">Topics</p>
                                <div class="--icon c-icon__accordion"></div>
                            </button>
                            <div data-js-accordion-target="" class="c-site-menu__children --single"
                                style="height: 0px;">
                                <div class="c-site-menu__children--inner">
                                    <div class="c-site-menu__children--item --last">
                                        <div data-js-accordion-target="" class="c-site-menu__children--nav">
                                            <div class="c-site-menu__children--list">
                                                <div class="c-site-menu__children--item">
                                                    <a href="/news/page/1"
                                                        class="c-site-menu__children--link ">
                                                        <p class="--text c-site-menu__children--text">News</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/pressrelease/page/1"
                                                        class="c-site-menu__children--link ">
                                                        <p class="--text c-site-menu__children--text">Press release</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                                <div class="c-site-menu__children--item">
                                                    <a href="/events/page/1"
                                                        class="c-site-menu__children--link --last">
                                                        <p class="--text c-site-menu__children--text">Event/Seminer</p>
                                                        <div class="c-site-menu__icon">
                                                            <svg viewBox="0 0 16 16" class="c-icon__full">
                                                                <use xlink:href="#svg-arrow"></use>
                                                            </svg>
                                                        </div>
                                                    </a>
                                                    <!--
                                                              -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="--item c-site-menu__item" style="--delay: 250ms;">
                        <div class="c-site-menu__item--inner">
                            <a href="/in-pocket" class="c-site-menu__link">
                                <p class="--text c-site-menu__text font-upgrade">Blog</p>
                            </a>
                        </div>
                    </li>
                    <li class="--item c-site-menu__item" style="--delay: 300ms;">
                        <div class="c-site-menu__item--inner">
                            <a href="/recruit" class="c-site-menu__link">
                                <p class="--text c-site-menu__text font-upgrade">Recruit</p>
                            </a>
                        </div>
                    </li>
                </ul>
            </nav>

            <div class="--cta prj-header__menu--cta" style="--delay: 350ms;">

                <div class="c-button__base --icon --full color-contact">
                    <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                        href="/contact" class="c-button__base--link c-link__button">
                        <span class="--bg c-button__base--bg"></span>
                        <p class="--text c-button__base--text">お問い合わせ</p>
                        <div class="c-button__base--icon">
                            <svg viewBox="0 0 20 20" class="--icon c-icon__full">
                                <use xlink:href="#svg-arrow"></use>
                            </svg>
                        </div>
                    </a>
                </div>

                <div class="c-button__base --icon --full color-download">
                    <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                        href="/download" class="c-button__base--link c-link__button">
                        <span class="--bg c-button__base--bg"></span>
                        <p class="--text c-button__base--text">資料ダウンロード</p>
                        <div class="c-button__base--icon">
                            <svg viewBox="0 0 20 20" class="--icon c-icon__full">
                                <use xlink:href="#svg-arrow"></use>
                            </svg>
                        </div>
                    </a>
                </div>

                <div class="c-button__base --icon --full color-download">
                    <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                        href="/mailmagazine" class="c-button__base--link c-link__button">
                        <span class="--bg c-button__base--bg"></span>
                        <p class="--text c-button__base--text">メールマガジン</p>
                        <div class="c-button__base--icon">
                            <svg viewBox="0 0 20 20" class="--icon c-icon__full">
                                <use xlink:href="#svg-arrow"></use>
                            </svg>
                        </div>
                    </a>
                </div>
            </div>

            <div class="--other prj-header__menu--other" style="--delay: 400ms;">
                <a href="/" class="prj-header__menu--other--link c-link" target="_blank">
                    <p class="prj-header__menu--other--text">Tech Blog</p>
                    <div class="prj-header__menu--other--icon">
                        <svg viewBox="0 0 20 20" class="c-icon__normal">
                            <use xlink:href="#svg-external"></use>
                        </svg>
                    </div>
                </a>
            </div>
        </div>
    </div>

    <span data-js-header-mask="" class="c-display__block--xl prj-header__mask c-effect__mask"></span>
  </header>
`

  if (isUIUXLpPage) {
    return <LPUIUXHeader />
  }
  if (isFrontendBackendLpPage) {
    return <LPFrontendHeader />
  }
  if (isDesignSystemLpPage) {
    return <LPDesignSystemHeader />
  }
  if (isFlamingoPage) {
    return (
      <>
        <div style={{ display: 'none' }}>{ReactHtmlParser(htmlContent)}</div>
        <LPFlamingoHeader />
      </>
    )
  }
  if (isAgreementPage) {
    return <></>
  }
  return (
    //20250124コメントアウト
    //<header className={styles.header} ref={header}>
    //  <div className={styles.container}>
    //    <div className={styles.flex} ref={flex}>
    //      <Logo />
    //      <MenuBar />
    //      <BurgerMenu />
    //    </div>
    //  </div>
    //</header>
    <>{ReactHtmlParser(htmlContent)}</>
  )
}

export default Header
